import { render, staticRenderFns } from "./Ministries.vue?vue&type=template&id=643a19cb&scoped=true&lang=pug&"
import script from "./Ministries.vue?vue&type=script&lang=js&"
export * from "./Ministries.vue?vue&type=script&lang=js&"
import style0 from "./Ministries.vue?vue&type=style&index=0&id=643a19cb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a19cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
